import React from "react";
import { useTranslation } from "react-i18next";
import { QuestionsAndAnswersList } from "./QuestionsAndAnswersList";
import { questionsAndAnswersTrns } from "../trns";

export const QuestionsAndAnswers = () => {
  const { t } = useTranslation();

  return (
    <section className="container pt-10 lg:pt-20">
      <h2 className="text-2xl text-purple-base text-center">
        {t(questionsAndAnswersTrns.title)}
      </h2>

      <QuestionsAndAnswersList />
    </section>
  );
};
